export const STATE_BUDGET = {
  INIT: 'INIT',
  FINALIZED: 'FINALIZED',
};

export const STRUCTURE_ITEM_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  CLOSED: 'CLOSED',
};
